import { render } from "./allstockadjustment.vue?vue&type=template&id=5076031a"
import script from "./allstockadjustment.vue?vue&type=script&lang=js"
export * from "./allstockadjustment.vue?vue&type=script&lang=js"

import "./allstockadjustment.vue?vue&type=style&index=0&id=5076031a&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__